import { Button, Typography, useTheme } from '@mui/material';

interface IProps {
	disabled?: boolean;
	handleClick: any;
	text: string;
	styleObj?: any;
	icon?: any;
	variantType?: 'text' | 'contained' | 'outlined';
	className?: string;
}
export const ButtonComponent = ({
	disabled,
	handleClick,
	text,
	styleObj,
	icon,
	variantType,
	className = '',
}: IProps) => {
	const theme = useTheme();
	return (
		<Button
			variant={variantType || 'contained'}
			disabled={disabled || false}
			onClick={handleClick}
			className={className}
			sx={{
				padding: '9px 10px',
				height: '32px',
				borderRadius: '4px',
				'&.MuiButton-contained:hover': {
					backgroundColor: theme.palette.root.basicDeepGreen,
				},
				'&.MuiButton-contained:focus': {
					backgroundColor: theme.palette.root.basicDeepGreen,
				},
				...styleObj,
			}}
		>
			<Typography variant="body" sx={{ marginRight: icon ? 1 : 0 }}>
				{text}
			</Typography>
			{icon}
		</Button>
	);
};
